(function() {
  angular
    .module('cfn')
    .factory('fertilizerCoreDataResolver', fertilizerCoreDataResolver);

  fertilizerCoreDataResolver.$inject = ['Fertilizer'];
  function fertilizerCoreDataResolver(Fertilizer) {
    return function() {
      return coreCommonResolveFunction(Fertilizer, false);
    };
  }
})();
